import styled, { css } from "styled-components";
import { V3Caption } from "../Typography";
import { AuthoryColorSchemes } from "./V3ProfileHero.types";
import { media, theme } from "../../theme/theme";
import { AuthoryColorSchemeProps, getFontColor, UserThemableHeading } from "../ReusableStyledComponents/FontSetUtilities";
import { hexToRgba } from "../../utils/hexToRGBA";
import { CUSTOM_FONT_SET_SIZES } from "../../utils/getFontSetLabels";

const sharedIconCSS = css<AuthoryColorSchemeProps & { $isPrimary?: boolean}>`
    border: ${({ $colorVariant, $customBackgroundColor, theme }) => `1px solid ${hexToRgba(getFontColor( $customBackgroundColor || theme.customization.backgroundColor,  $colorVariant),  0.2 )} `};
    
    &:hover {
        cursor: pointer;
        background: ${({ $colorVariant, theme }) => $colorVariant === AuthoryColorSchemes.light ? "rgba(255,255,255,0.8)" : hexToRgba(theme.customization.accentcolour, 0.3)};
        color:  ${({ $colorVariant, theme, $customBackgroundColor }) => $colorVariant === AuthoryColorSchemes.light ? theme.v3.colors.ink : hexToRgba(getFontColor( $customBackgroundColor || theme.customization.backgroundColor,  $colorVariant),  1 )};
    }
`;

export const SocialSVG = styled.div <AuthoryColorSchemeProps>`
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        &:not(.skip-fill) {
            path {
                fill: ${({ theme, $colorVariant,  $customBackgroundColor, $customDarkShade }) => getFontColor( $customBackgroundColor || theme.customization.backgroundColor, $colorVariant, $customDarkShade)};
            }
        }

        &.skip-fill {
            path {
                stroke: ${({ theme, $colorVariant,  $customBackgroundColor, $customDarkShade }) => getFontColor(  $customBackgroundColor || theme.customization.backgroundColor, $colorVariant, $customDarkShade)};
            }
        }
    }

    &:hover {
        svg {
            rect {
                fill: ${({ $colorVariant }) => $colorVariant === AuthoryColorSchemes.light ? "white" : undefined};
                opacity: ${({ $colorVariant }) => $colorVariant === AuthoryColorSchemes.light ? "0.8" : undefined};
                stroke: ${({ $colorVariant }) => $colorVariant === AuthoryColorSchemes.light ? "white" : undefined};
                stroke-opacity: 1;
            }

            &:not(.skip-fill) {
                path {
                    fill: ${({ $colorVariant, theme }) => $colorVariant === AuthoryColorSchemes.light ? theme.v3.colors.ink : undefined};
                }
            }

            &.skip-fill {
                path {
                    stroke: ${({ $colorVariant, theme }) => $colorVariant === AuthoryColorSchemes.light ? theme.v3.colors.ink : undefined};
                }
            }
        }
    }

    ${sharedIconCSS}
`;

const UserThemableContactMeButton = styled(V3Caption)<AuthoryColorSchemeProps>`
    ${UserThemableHeading}
`;

export const ContactMeButton = styled(UserThemableContactMeButton)<{ $isPrimary?: boolean}>`
    padding: 5px 16px;
    border-radius: 100px;
    background: ${({ $colorVariant, theme, $isPrimary }) => {
        if(!$isPrimary) return "transparent";
        if($colorVariant === AuthoryColorSchemes.light) return  hexToRgba("#FFFFFF", 0.2)
        return hexToRgba(theme.customization.accentcolour, 0.2);
    }};
    width: auto;
    max-width: 250px;
    height: 36px;
    white-space: nowrap;
    max-width: 180px;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: ${({ theme }) => {
        if (CUSTOM_FONT_SET_SIZES.includes(theme.customization.profileFontSet)) {
            return "14px";
        }
    }};

    ${sharedIconCSS}
`

export const ProfileSocialsWrapper = styled.div<{ $customJustify?: string }>`
    display: flex;
    position: relative;
    flex-wrap: wrap;
    justify-content: ${({ $customJustify }) => $customJustify || "center"}; 

    ${media.custom(theme.breakpoints.phone)} {
        flex-wrap: nowrap;
    }

    > div {
        display: inline-flex;

        ${media.custom(theme.breakpoints.phone)} {
            margin-top: 0;
        }
        
        a {
            display: inline-flex;
        }

        &:not(:last-child) {
            margin-right: 10px;
        }
    }
`;
